<template>
  <v-text-field
    variant="outlined"
    density="compact"
    persistentPlaceholder
    hideDetails
    type="number"
    :modelValue="modelValue[0]"
    placeholder="e.g.: 250"
    @update:modelValue="v => (modelValue = [v, 0])"
  >
    <template #append-inner>
      <v-select
        density="compact"
        variant="plain"
        :modelValue="modelValue[1]"
        :disabled="measures.length <= 1"
        class="m-0 -mt-2 w-16 p-0"
        hideDetails
        :items="measures"
        @update:modelValue="v => (modelValue = [v, 1])"
        @click.stop.prevent
        @mousedown.stop.prevent
      />
    </template>
  </v-text-field>
</template>

<script setup>
import { DEFAULT_MEASURES } from "@/utils/composables/useCSSProperty";

defineProps({ measures: { type: Array, default: () => DEFAULT_MEASURES } });
const modelValue = defineModel({ type: Array, default: () => [0, 0] });
</script>
